import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

function UsePreviousRoute() {
    const location = useLocation();
    const prevPath = useRef(null);

    useEffect(() => {
        if (prevPath.current) {
            sessionStorage.setItem("PREV_ROUTE", prevPath.current);
        }
        prevPath.current = location.pathname;
    }, [location.pathname]);

    return null;

}
export default UsePreviousRoute;